import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

import { stylingHelpers } from '../../designTokens';
import Text from '../chrome/Text';
import Image from '../chrome/Image';
import LoadingIcon from '../chrome/LoadingIcon';

const { fixTop, flexCenter } = stylingHelpers;

const containerBaseStyles = css`
  width: 100%;
  height: 100%;
  ${flexCenter()};
`;

const containerFixedStyles = ({ isFixed }) =>
  isFixed &&
  css`
    ${fixTop()}
  `;

const Container = styled('div')`
  ${containerBaseStyles};
  ${containerFixedStyles};
`;

const wrapperBaseStyles = css`
  ${flexCenter()};
  flex-wrap: wrap;
`;

const Wrapper = styled('div')`
  ${wrapperBaseStyles};
`;

const loadingImageContainerBaseStyles = ({ theme }) => css`
  fill: ${theme.colors.n700};
  margin-bottom: ${theme.spacings.giga};
  max-width: 52px;
  min-height: 39px;
  ${flexCenter()}
`;

const LoadingImageContainer = styled('div')`
  ${loadingImageContainerBaseStyles};
`;

const loadingTextBaseStyles = ({ theme }) => css`
  margin-top: ${theme.spacings.giga};
`;

const LoadingText = styled('div')`
  ${loadingTextBaseStyles};
`;

const Loader = ({ assetUrl, assetAlt, isSvg, text, isFixed }) => {
  return (
    <Container isFixed={isFixed}>
      <Wrapper>
        <LoadingImageContainer>
          <Image src={assetUrl} alt={assetAlt} isSvg={isSvg} />
        </LoadingImageContainer>
        <LoadingIcon />
        <LoadingText>
          <Text size='tera' bold>
            {text}
          </Text>
        </LoadingText>
      </Wrapper>
    </Container>
  );
};

Loader.defaultProps = {
  isFixed: true,
};

Loader.propTypes = {
  assetUrl: PropTypes.string,
  assetAlt: PropTypes.string,
  text: PropTypes.string,
  isSvg: PropTypes.bool,
  isFixed: PropTypes.bool,
};

export default Loader;
